import { render } from "./Base.vue?vue&type=template&id=683552f8&ts=true"
import script from "./Base.vue?vue&type=script&lang=ts"
export * from "./Base.vue?vue&type=script&lang=ts"

import "./Base.vue?vue&type=style&index=0&id=683552f8&lang=scss"

import exportComponent from "D:\\work\\h5\\2024sjAnswer\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__